<template>
  <div v-if="items.length">
    <Title>Agenda</Title>
    <div>
      <div v-for="({ to, title, date, local }, i) in items" :key="i">
        <Schedule :to="to" :title="title" :date="date" :local="local" />
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/widgets/Title.vue";
import Schedule from "@/components/cards/Schedule.vue";
import { formatToURL } from "@/components/utils";
import { eventsCount } from "@/config.js";

const _config = {
  mod: "events",
  path: "agenda",
};

export default {
  data: () => ({
    items: [],
  }),
  methods: {
    parseDate(v) {
      return new Date(v)
        .toLocaleString("pt-BR", {
          day: "2-digit",
          month: "long",
        })
        .split(/\sde\s/);
    },
  },
  beforeCreate() {
    this.$rest(_config.mod)
      .get({
        params: {
          itemsPerPage: eventsCount,
        },
      })
      .then((data) => {
        this.items = data.map(({ id, date, title, local }) => ({
          title,
          to: `/${_config.path}/${formatToURL(`${title}-${id}`)}`,
          date: this.parseDate(date),
          local,
        }));
      });
  },
  components: {
    Title,
    Schedule,
  },
};
</script>
